import { render, staticRenderFns } from "./Listcate.vue?vue&type=template&id=6f2cac7c&"
import script from "./Listcate.vue?vue&type=script&lang=js&"
export * from "./Listcate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports